import React, { Fragment, useEffect, useState } from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import CustomNavbar from './components/custom_navbar/CustomNavbar';
import Landing from './pages/landing/Landing';
import MouseTracker from './components/mouse_tracker/MouseTracker';
import { pages } from './Constants';
import Footer from './components/footer/Footer';

export default function App() {
  const [showLanding, setShowLanding] = useState(true);
  useEffect(() => {
    const isLandingShown = sessionStorage.getItem('isLandingShown');
    if (isLandingShown === 'true') {
      setShowLanding(false);
    } else {
      sessionStorage.setItem('isLandingShown', 'false');
      setShowLanding(true);
    }
  }, []);
  function handleRender() {
    sessionStorage.setItem('isLandingShown', 'true');
    setShowLanding(false);
  }

  return (
    <Fragment>
      <MouseTracker />
      {showLanding ? <Landing handleRender={handleRender} /> :
        <Fragment>
          <CustomNavbar />
          <Routes>
            <Route path='/' element={<Navigate to='/home' replace />} />
            {pages.map((pageInfo, index) => {
              return <Route key={index} path={pageInfo.url} element={<pageInfo.component />} />
            })}
          </Routes>
          <Footer />
        </Fragment>}
    </Fragment>
  )
}
